/*
 * HS custom – Hector Saxe
 * Code sur mesure sorti de theme.js (Prestige) pour survivre aux mises à jour du thème.
 */

/* Section Timeline : flèches précédent / suivant autour de la navigation (voir sections/timeline.liquid) */
document.addEventListener('DOMContentLoaded', function () {
  var timelines = document.querySelectorAll('[data-timeline]');

  timelines.forEach(function (timeline) {
    var navButtons = timeline.querySelectorAll('.timeline__nav button');
    var prevBtn = timeline.querySelector('[data-timeline-prev]');
    var nextBtn = timeline.querySelector('[data-timeline-next]');

    if (!navButtons.length) return;

    function getActiveIndex() {
      var index = Array.prototype.findIndex.call(navButtons, function (btn) {
        return btn.getAttribute('aria-current') === 'true';
      });

      if (index === -1) index = 0;
      return index;
    }

    function goTo(index) {
      if (index < 0) {
        index = navButtons.length - 1;
      } else if (index >= navButtons.length) {
        index = 0;
      }

      navButtons[index].click();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var current = getActiveIndex();
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var current = getActiveIndex();
        goTo(current + 1);
      });
    }
  });
});
